import { Button } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import React, { FC, useState } from 'react';

interface Props {
    applyFilter: (field:string, conditions: Array<string>) => void;
    firstCheckboxTitle: string;
    secondCheckboxTitle: string;
    thirdCheckboxTitle: string;
    field: string;
    selectedItem?: Array<string>
}

const CreditFilter: FC<Props> = ({ applyFilter, firstCheckboxTitle, secondCheckboxTitle, thirdCheckboxTitle, field, selectedItem }) => {
    const [state, setState] = useState({
        selectedItem: selectedItem || Array<string>()
    })

    const clearFilter = () => {
        setState({ ...state, selectedItem: Array<string>() })
    }

    const handleChecked = (name: string): boolean => {
        let checked = false
        state.selectedItem.map((item) => {
            if (name === item) {
                checked = true
            }
        })
        return checked
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selected = state.selectedItem
        const checked = event.target.checked
        const name = event.target.value
        if (checked) {
            selected.push(name)
        } else {
            state.selectedItem.map((item,i)=> {
                if (name === item) {
                    selected.splice(i,1)
                }
            })
        }
        setState({...state, selectedItem: selected})
    }

    return (
        <>
            <div className="filter-dropdown">
                <Box>
                    <Box display="flex" alignItems="center">
                        <input
                            type="checkbox"
                            value={firstCheckboxTitle}
                            checked={handleChecked(firstCheckboxTitle) ? true : false}
                            onChange={handleChange}
                        />
                        <div>
                            {firstCheckboxTitle}
                        </div>
                    </Box>
                    <Box display="flex" alignItems="center">
                        <input
                            type="checkbox"
                            value={secondCheckboxTitle}
                            checked={handleChecked(secondCheckboxTitle) ? true : false}
                            onChange={handleChange}
                        />
                        <div>
                            {secondCheckboxTitle}
                        </div>
                    </Box>
                    <Box display="flex" alignItems="center">
                        <input
                            type="checkbox"
                            value={thirdCheckboxTitle}
                            checked={handleChecked(thirdCheckboxTitle) ? true : false}
                            onChange={handleChange}
                        />
                        <div>
                            {thirdCheckboxTitle}
                        </div>
                    </Box>
                    <Box display="flex" justifyContent="space-evenly" alignItems="center" paddingTop="1em">
                        <Button id="apply-button" onClick={()=>applyFilter(field, state.selectedItem)}>Filter</Button>
                        <Button id="clear-button" onClick={clearFilter}>Clear</Button>
                    </Box>
                </Box>
            </div>
        </>
    )
}

export default CreditFilter